import gsap from 'gsap';
export default class PushContact {
    constructor() {
        this.display();
        this.events();
    }

    display() {
        const elt = document.querySelector('.contact');
        if(elt) {
            setTimeout(() => {
                elt.style.opacity = '1';
            }, 200);
            gsap.fromTo(
                elt,
                {
                    x: elt.offsetWidth * 2,
                    ease: "power4.out",
                    duration: 0.85,
                },
                {
                    x: elt.offsetWidth,
                    delay: 1,
                    onComplete: function() {
                        gsap.set(this.targets(), { clearProps: "all" });
                        elt.style.opacity = '1';
                    }
                }
            );
        }
    }

    events() {
        const btn = document.querySelector('.contact__toggle');
        if(btn) {
            btn.addEventListener('click', () => {
                document.querySelector('.contact').classList.toggle('js-open');
            });
        }
    }
}